// TODO use date formatting package
export function formatISOStringForView({ value: s }: { value: string }) {
  const [, year, month, date] = s.match(/^(\d{4})-(\d{2})-(\d{2})/) || [];

  return `${month}/${date}/${year}`;
}
